/**
 * The bundled system images, gathered by webpack at build time.
 *
 * `require.context` must be called directly at module level so webpack can
 * process it, and it does not exist under Jest. Keeping the call in its own
 * module lets tests replace it with `jest.mock("./systemImagesContext")` and
 * render the real MediaLibrary instead of a hand-written copy of it.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const systemImagesContext = (require as any).context(
  "../../assets/system-images",
  true,
  /\.(png|jpe?g|svg|webp)$/i
);

export default systemImagesContext;
